import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PSContextWrapper from "@my-dld/contexts/PSContext";
import { Route, Switch } from "react-router";
import SellerRequestForm from "./SellerFlow/SellRequest";
import { appendPath } from "@my-dld/utils/PathUtils";
import PrivateSellRequests from "../MyDLD/MyRequest/PSellRequests";
import BookingRequestDetails from "./SellerFlow/BookingRequestDetails";
import PropertyTransaction from "./SellerFlow/PropertyTransaction";
import SearchByBookingRef from "./BuyerFlow/SearchByBookingRef";
import AcceptRequest from "./BuyerFlow/AcceptRequest";
import BookingPayment from "./BuyerFlow/BookingPayment";

export default class PrivateSell extends Component<RoutedViewProps> {
	constructor( props: RoutedViewProps ) {
		super( props );
	}

	render() {
		const pp = this.props.match.url;
		return <PSContextWrapper>
			<Switch>
				<Route
					path={ pp } exact={ true }
					component={ PropertyTransaction }/>
				<Route
					path={ appendPath( pp, "/:tabuPropertyID" ) }
					exact={ true } component={ SellerRequestForm }/>
			</Switch>
		</PSContextWrapper>;
	}
}

export class MyRequestPrivateSell extends Component<RoutedViewProps> {
	constructor( props: RoutedViewProps ) {
		super( props );
	}

	render() {
		const pp = this.props.match.url;
		return <PSContextWrapper>
			<Switch>
				<Route
					path={ pp } exact={ true }
					component={ PrivateSellRequests }/>
				<Route
					path={ appendPath( pp, "/:requestId" ) }
					exact={ true } component={ BookingRequestDetails }/>
				<Route
					path={ appendPath( pp, "/:tabuPropertyID" ) }
					exact={ true } component={ SellerRequestForm }/>
			</Switch>
		</PSContextWrapper>;
	}
}

export class BookingFlow extends Component<RoutedViewProps> {
	constructor( props: RoutedViewProps ) {
		super( props );
	}

	render() {
		const pp = this.props.match.url;
		return <PSContextWrapper>
			<Switch>
				<Route
					path={ pp } exact={ true }
					component={ SearchByBookingRef }/>
				<Route
					path={ appendPath( pp, "/:referenceId" ) }
					exact={ true } component={ BookingRequestDetails }/>
				<Route
					path={ appendPath( pp, "/accept/:referenceId" ) }
					exact={ true } component={ AcceptRequest }/>
				<Route
					path={ appendPath( pp, "/payment/:referenceId" ) }
					exact={ true } component={ BookingPayment }/>
			</Switch>
		</PSContextWrapper>;
	}
}
